import React, {Component} from "react"
import {Alert, Modal, ModalBody, ModalHeader,} from "reactstrap";
import PropTypes from "prop-types";

class ApproveBlockModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: '',
        };
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                scrollable={true}
                backdrop={'static'}
                id="staticBackdrop"
            >
                <ModalHeader toggle={this.props.onCancel}>
                    [#{this.props.approve ? this.props.approve.id : ''}] 입장 신청 차단
                </ModalHeader>
                <ModalBody>
                    <Alert color="danger" role="alert">
                        <b>아래 사용자의 레쿠 소통방 입장 신청을 차단할까요?</b>
                        <br/><br/>
                        트위터 닉네임: {this.props.approve ? this.props.approve.twitterName : ''}
                        <br/>
                        트위터 아이디: @{this.props.approve ? this.props.approve.twitterUsername : ''}
                        <br/><br/>
                        <b>주의: 차단된 사용자는 관리자가 차단을 해제하지 않는 한 다시는 요청을 보낼 수 없습니다.</b>
                    </Alert>

                    <div>
                        <label htmlFor="reason" className="form-label">사유</label>
                        <input
                            type="text"
                            className="form-control"
                            id="reason"
                            placeholder="사유가 있다면 적어주세요. (요청자에게 차단 사유로 보여집니다)"
                            value={this.state.reason}
                            onChange={e => this.setState({reason: e.target.value})}
                        />
                    </div>
                </ModalBody>
                <div className="modal-footer">
                    <button type="button" className="btn btn-light"
                            onClick={() => this.props.onCancel()}>
                        취소
                    </button>
                    <button type="button" className="btn btn-danger"
                            onClick={() => this.props.onSubmit(this.state.reason)}>
                        입장 신청 차단
                    </button>
                </div>
            </Modal>
        )
    }
}

ApproveBlockModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    approve: PropTypes.object,

    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default ApproveBlockModal;
